module.exports = __webpack_public_path__ + "static/media/maskchains.0075ef43.jpeg";